import { PublicPageShell, Section } from "../components/PublicPageShell";

export default function Privacy() {
  return (
    <PublicPageShell overline="Your data" title="Privacy Policy" updated="February 2026" testId="privacy-page">
      <Section heading="Who we are">
        <p>
          SphereInvest AI is operated by Three Spheres Healthcare Limited, a company registered in England and Wales
          (Company No. 14029879). Registered address available on the Companies House register (No. 14029879).
          Questions about this policy: <a href="mailto:info@threesphereshealthcare.org" className="text-primary hover:underline">info@threesphereshealthcare.org</a>.
        </p>
      </Section>

      <Section heading="What we collect and why">
        <ul className="list-disc pl-5 space-y-2">
          <li><span className="text-white">Account data</span> — email, name and a securely hashed password (we never store plain-text passwords), or your Google account email if you sign in with Google. Used to operate your account.</li>
          <li><span className="text-white">Your research data</span> — portfolios, holdings, watchlists, ISA contribution records, lesson progress and research-assistant conversations. Used solely to provide those features to you.</li>
          <li><span className="text-white">Billing data</span> — if you subscribe, PayPal processes the payment; we store only the subscription reference and status, never card or bank details.</li>
          <li><span className="text-white">Usage counters</span> — we count AI requests per account to enforce fair-use limits.</li>
        </ul>
      </Section>

      <Section heading="AI processing">
        <p>
          When you use an AI feature, relevant context — for example your portfolio holdings, cached market data for
          the tickers involved, and your question — is sent to our AI provider (Anthropic Claude, accessed via
          Emergent) to generate the insight. It is used to produce your response and is not used by us to train
          models.
        </p>
      </Section>

      <Section heading="Cookies and analytics">
        <p>
          We use a single essential cookie for authentication (keeping you signed in). We do not use analytics or
          tracking cookies, we do not record your sessions, and we do not sell personal data or use advertising
          trackers. Because we only use a strictly necessary cookie, no consent banner is required.
        </p>
      </Section>

      <Section heading="Retention and deletion">
        <p>
          Your data is kept while your account is active. You can delete your account at any time from the account
          menu ("Delete my account"): this cancels any active subscription and permanently removes your account,
          portfolios, watchlists, conversations, ISA records, lesson progress, shared research cards and usage
          counters. Deletion is immediate and irreversible. Aggregated, non-identifying market data caches are not
          linked to you and are unaffected.
        </p>
      </Section>

      <Section heading="Your rights">
        <p>
          Depending on your location you may have rights to access, correct, export or erase your personal data, and
          to complain to a supervisory authority (in the UK, the ICO). Contact <a href="mailto:info@threesphereshealthcare.org" className="text-primary hover:underline">info@threesphereshealthcare.org</a> to exercise them.
        </p>
      </Section>
    </PublicPageShell>
  );
}
